import React, { useState } from "react"
import { Collapse } from "reactstrap"


const FaqData = [
    {
        question: "Why is it 20% for salary earners and 30% for business owners?",
        answer: "The equity contribution differs because salaried income is usually more stable and predictable, while business income can fluctuate. The higher equity contribution for business owners helps to reduce repayment risk and keeps the monthly repayment more comfortable for them."
    },
    {
        question: "Why did you increase the tenor of my loan?",
        answer: "In some cases, the tenor may be adjusted to reduce the monthly repayment obligation and make the repayment plan more affordable based on the customer’s income profile and financial assessment."
    },
    {
        question: "Do you finance other things or is it only solar?",
        answer: "In addition to solar financing, we may also finance other products depending on the available financing programs and eligibility criteria."
    },
    {
        question: "Where is your office located?",
        answer: "We currently have physical offices in Lagos, Abuja, and Sokoto. However, our operations and services extend across all the 36 States of Nigeria, including the FCT."
    },
    {
        question: "What if I want to pay more than the stipulated amount for my monthly payment?",
        answer: "Yes, you can absolutely pay more than your stipulated monthly repayment amount. Making extra payments can help reduce your outstanding balance faster and may also shorten your repayment period. Kindly notify us whenever you make an excess payment so we can properly document and apply it to your account."
    },
    {
        question: "How long will it take to get approval?",
        answer: "Approval timelines vary depending on document completeness and assessment outcomes. However, applications are typically reviewed and an update provided within 6 to 18 hours after all required documents have been submitted."
    },
    {
        question: "What if I want to liquidate before the expiration of my loan tenor?",
        answer: "Yes, early liquidation is allowed. If you choose to liquidate your loan before the end of the tenor, we will compute your outstanding balance and provide the exact amount for settlement. The key advantage of liquidation is that your financing term is brought to a close early, and you do not pay the full interest that would have accrued over the remaining tenor, making it a cost-saving option for early repayment."
    },
    {
        question: "Is the interest fixed or on a reducing balance?",
        answer: "The interest rate is fixed at 4% flat per month throughout the repayment period. This means the repayment structure is predictable, so customers can easily plan because the monthly installment amount remains the same from start to finish and does not fluctuate over time."
    },
    {
        question: "Why do you need my BVN?",
        answer: "Your BVN (Bank Verification Number) is required as part of our KYC process to verify your identity and comply with CBN regulations. It also allows us to access credit bureau information to review your credit profile, including your credit score, existing loans, and repayment history, which helps us make a responsible lending decision."
    },
    {
        question: "Will you send the money to the vendor or to me?",
        answer: "We will not disburse the funds directly to you. The payment is made directly to the approved vendor, who also serves as the installer. This ensures they can procure the required solar equipment and carry out the installation. Once the equity contribution, administrative fee, and all required documentation are completed, the full invoice amount is paid to the vendor for proper execution and accountability of the project."
    },
    {
        question: "Is direct debit a must on my account?",
        answer: "Yes, direct debit is required as it helps ensure reliable and timely repayment. We typically set it up through Mono or Remita, and we also accept post-dated cheques as an alternative repayment arrangement."
    }
];

const SolarFinancingFAQs = ({ displaySeeMore }) => {
    const [curent, setCurrent] = useState("")
    const [displayMore, setDisplayMore] = useState(false)
    return (
        <div className="frequent-question">
            <h1>Frequently Asked Questions</h1>
            {
                FaqData.slice(0, displayMore ? FaqData.length : 5).map((item, index) => (
                    <React.Fragment key={index}>
                        <div
                            className={curent === index.toString() ?
                                "question-box2 d-flex justify-content-between align-items-center" :
                                "question-box d-flex justify-content-between align-items-center"
                            }
                        >
                            <div className="text m-3">
                                {item.question}
                            </div>
                            <button
                                className="btn border-0 text m-3"
                                onClick={() => { setCurrent(curent === index.toString() ? "" : index.toString()) }}>
                                {curent === index.toString() ? "-" : "+"}
                            </button>
                        </div>
                        <Collapse isOpen={curent === index.toString()}>
                            <div className="m-3 answer">
                                <p className="font-size-11">
                                    {item.answer}
                                </p>
                            </div>
                        </Collapse>
                    </React.Fragment>
                ))
            }




            {displaySeeMore && <div className="text-center w-25 m-auto mt-5 see-more">
                {displayMore ?
                    <button
                        className="btn btn-primary shadow-none"
                        onClick={() => setDisplayMore(false)}>
                        see less -
                    </button> :
                    <button
                        className="btn btn-primary shadow-none"
                        onClick={() => setDisplayMore(true)}>
                        see more +
                    </button>
                }
            </div>}
        </div>
    )
}

export default SolarFinancingFAQs